module.exports = __webpack_public_path__ + "img/FISSA_EE.5812e893.png";